const Menu = () => {
	// Menu
	const menu = document.querySelector('.main-header');
	window.addEventListener('scroll', (e) => {
		if (document.body.scrollTop > window.innerHeight || document.documentElement.scrollTop > 300) {
			menu.classList.add('is-active');
		} else {
			menu.classList.remove('is-active');
		}
	});


	let menuhasChild =  document.querySelectorAll('.main-menu .parent > a');
	menuhasChild.forEach((parent) => {
		parent.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			parent.closest('.parent').classList.toggle('is-active');
		});
	})
}
export default Menu;